import React, { useState, useEffect } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import itemsModules from '../ItemsModules/itemsSlider';
import TitleLineH1 from './TitleLineH1';
import SimpleTag from './SimpleTag';
import LinkButtonRounded from './LinkButtonRounded';
import SubtitleLineH2 from './SubtitleLineH2';
import PretitleLineH2 from './PretitleLineH2';
import { move, copy, reorder } from '../../../../utils/dragAndDrop';

import imageModifier from '../../../../utils/imageModifier';
import SingleObjUploaderWithSelector from '../../Mam/SingleObjUploaderWithSelector';
import Modal from '../../../Modal/Modal';
import uuid from 'react-uuid';

export const SLIDER_LAYOUT_DESTINATION = 'SliderBannerDestination';
export const SLIDER_LAYOUT_TICKETS = 'SliderBannerTickets';

const initialState = {
  type: 'SliderBannerHome',
  image: {
    en: '',
  },
  left: [],
  right: [],
  areSlidesShort: false,
  scheduledDate: null,
  url: null,
  dropDownItems: [
    { label: '', link: '' },
    { label: '', link: '' },
    { label: '', link: '' },
    { label: '', link: '' },
  ],
};

const grid = 4;

const Slider = ({
  activeLanguage,
  carouselIndex,
  handlerSetCarouselComponents,
  handlerSetSlider,
  components,
  id,
  reusableComponent,
  reusableComponentSlugname,
  languages,
  areSlidesShort = false,
  isRecord = false,
  selected,
}) => {
  // console.log('initialComponents', components);
  // console.log('reusableComponentsComponents', reusableComponent);
  const isDestinationLayout = isRecord === SLIDER_LAYOUT_DESTINATION;
  const isTicketsLayout = isRecord === SLIDER_LAYOUT_TICKETS;

  const getItemStyleContent = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    color: 'white',
    margin: `0 0 ${grid}px 0`,
    borderRadius: '4px',

    // change background colour if dragging
    background: isDragging ? 'lightgreen' : '#292929',

    // styles we need to apply on draggables
    ...draggableStyle,
  });

  const getItemStyleType = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    // padding: grid * 4,
    border: '1px solid #dae1e7',
    margin: '5.5% 4% 0 4%',
    borderRadius: '5px',

    // change background colour if dragging
    background: 'white',

    // styles we need to apply on draggables
    ...draggableStyle,
  });

  const getListStyleContent = isDraggingOver => ({
    background: 'black',
    padding: '10px 16px',
    position: 'absolute',
    top: 0,
    left: -1,
    width: '11.5%',
    height: '100%',
    marginLeft: '1.875rem',
  });

  const getListStyleType = (isDraggingOver, selectedLeft) => ({
    background: isDraggingOver ? 'transparent' : 'transparent',
    // padding: grid,
    // height: '54%',
    // position: 'absolute',
    // zIndex: 100,
    // top: '44.5%',
    border: '2px dashed #c8c8c8',
    borderRadius: '7px',
    paddingRight: '0rem',
  });

  const [selectedLeft, setSelectedLeft] = useState([]);
  const [selectedRight, setSelectedRight] = useState([]);
  const [items] = useState(itemsModules);
  const [sliderIndex, setIndex] = useState();
  const [state, setState] = useState(initialState);
  const [isModalOn, setModalState] = useState(false);

  const handlerSetSliderComponents = () => {
    const { image, left, right, url, showOpacity, dropDownItems } = state;
    const newSelected = selected;
    if (sliderIndex >= 0) {
      newSelected[sliderIndex].component.type = isRecord;
      newSelected[sliderIndex].component.compId = `${isRecord}_${uuid()}`;
      newSelected[sliderIndex].component.areSlidesShort = areSlidesShort;
      newSelected[sliderIndex].component.left = left;
      newSelected[sliderIndex].component.right = right;
      newSelected[sliderIndex].component.image = image;
      newSelected[sliderIndex].component.url = url;
      newSelected[sliderIndex].component.dropDownItems = dropDownItems;
      newSelected[sliderIndex].component.showOpacity = showOpacity;
      // NOTE: check transformCarouselToDnD to add or remove new props.

      handlerSetCarouselComponents(newSelected, carouselIndex);
    }
  };

  useEffect(() => {
    handlerSetSliderComponents();
  }, [state]);

  const handlerSetNestedComponentsLeft = (comp, index) => {
    const { component } = comp;

    selectedLeft[index].component = {
      ...component,
    };

    const newSelected = selectedLeft;
    newSelected[index].component = { ...component };

    setSelectedLeft(newSelected);
    setState({ ...state, left: newSelected });
  };

  const handlerSetNestedComponentsRight = (comp, index) => {
    const { component } = comp;

    selectedRight[index].component = {
      ...component,
    };

    const newSelected = selectedRight;
    newSelected[index].component = { ...component };

    setSelectedRight(newSelected);
    setState({ ...state, right: newSelected });
  };

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    if (reusableComponent) {
      setState(reusableComponent);
      if (!component) {
        handlerSetSlider(
          { component: { key: reusableComponentSlugname } },
          componentIndex,
        );
      }
    } else {
      setIndex(componentIndex);

      if (component) {
        setState(component);
      } else {
        const componentObj = {
          id,
          component: state,
        };
        handlerSetSlider(componentObj, componentIndex);
      }
    }

    if (component) {
      const sliderComponent = components[componentIndex].component;

      if (sliderComponent) {
        setSelectedLeft(sliderComponent.left);
        setSelectedRight(sliderComponent.right);
      }
    }
  }, [components]);

  const handleBlockClose = (componentId, side) => {
    if (side === 'left') {
      const componentToBeRemovedIndex = selectedLeft.findIndex(
        obj => obj.id === componentId,
      );
      const arr = [...selectedLeft];
      arr.splice(componentToBeRemovedIndex, 1);
      setSelectedLeft(arr);
      setState({ ...state, left: arr });
    } else {
      const componentToBeRemovedIndex = selectedRight.findIndex(
        obj => obj.id === componentId,
      );
      const arr = [...selectedRight];
      arr.splice(componentToBeRemovedIndex, 1);
      setSelectedRight(arr);
      setState({ ...state, right: arr });
    }
  };
  const onDragEnd = (result) => {
    const { source, destination } = result;

    if (!destination) {
      return;
    }

    switch (source.droppableId) {
      case destination.droppableId: {
        let newOrder;
        if (destination.droppableId === 'selectedLeft') {
          newOrder = reorder(selectedLeft, source.index, destination.index);
          setSelectedLeft(newOrder);
          setState({ ...state, left: newOrder });
        } else {
          newOrder = reorder(selectedRight, source.index, destination.index);
          setSelectedRight(newOrder);
          setState({ ...state, right: newOrder });
        }
        break;
      }
      case 'items': {
        if (destination.droppableId === 'selectedLeft') {
          const makeCopy = copy(items, selectedLeft, source, destination);
          setSelectedLeft(makeCopy);
          break;
        } else {
          const makeCopy = copy(items, selectedRight, source, destination);
          setSelectedRight(makeCopy);
          break;
        }
      }
      default: {
        let movedElements;
        if (source.droppableId === 'selectedLeft') {
          movedElements = move(
            selectedLeft,
            selectedRight,
            source,
            destination,
          );
        } else {
          movedElements = move(
            selectedRight,
            selectedLeft,
            source,
            destination,
          );
        }
        setSelectedLeft(movedElements.selectedLeft);
        setSelectedRight(movedElements.selectedRight);
        setState({ ...state, left: movedElements.selectedLeft, right: movedElements.selectedRight });
      }
    }
  };

  const toggleModal = () => {
    setModalState(!isModalOn);
  };

  const handleUrl = (e) => {
    const { value } = e.target;

    const comp = {
      ...state,
      url: value,
    };

    setState(comp);
  };

  const handleDropdownItem = (e) => {
    const { name, value } = e.target;
    const dataField = name.split('-');
    const typeValueDropdownItem = dataField[0];
    // eslint-disable-next-line radix
    const posDropdownItem = parseInt(dataField[1]);
    const cleanDropdownItems = [ // To do: Debería pillarlo siempre del initialState o de lo que le venga stored :(
      { label: '', link: '' },
      { label: '', link: '' },
      { label: '', link: '' },
      { label: '', link: '' },
    ];
    const updatedDropdownItems = state?.dropDownItems ? [...state.dropDownItems] : cleanDropdownItems;
    updatedDropdownItems[posDropdownItem][typeValueDropdownItem] = value;

    const comp = {
      ...state,
      dropDownItems: updatedDropdownItems,
    };

    setState(comp);
  };

  const setImage = ([image]) => {
    toggleModal();
    let comp = {};
    comp = {
      ...state,
      image: {
        ...state.image,
        [activeLanguage.toLowerCase()]: image.url,
      },
    };
    setState(comp);
    // }
  };

  const handleOpacityLayer = (e) => {
    const { checked } = e.target;
    const comp = {
      ...state,
      showOpacity: checked,
    };
    setState(comp);
  };

  if (activeLanguage !== 'en' && state.image && state.image.en && state.image.en.length && !state.image.hasOwnProperty(activeLanguage)) {
    // Set image of this language, if it is not set, to the same as the english image
    state.image[activeLanguage] = state.image.en;
  }

  const currentBgImageIs = (state && state.hasOwnProperty('image')) ? imageModifier(state.image[activeLanguage]) : imageModifier(state.image.en);
  return (
    <>
      {
        isTicketsLayout && (
          <div className="uppercase text-xs text-black font-bold my-2">
            Dropdown Items
            <div className="uppercase text-xs text-black font-bold my-2">
              {/* To do: Dynamic droDownItems */}
              <div className="dropDownItem flex">
                <div className="flex flex-col w-1/2 mr-2">
                  <div className="mt-2 block uppercase tracking-wide text-gray-700 text-xs text-black font-bold">
                    Label:
                  </div>
                  <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    name="label-0"
                    onChange={handleDropdownItem}
                    type="text"
                    value={state?.dropDownItems ? state?.dropDownItems[0]?.label : ''}
                  />
                </div>
                <div className="flex flex-col w-1/2">
                  <div className="mt-2 block uppercase tracking-wide text-gray-700 text-xs text-black font-bold">
                    Link:
                  </div>
                  <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    name="link-0"
                    onChange={handleDropdownItem}
                    type="text"
                    value={state?.dropDownItems ? state?.dropDownItems[0]?.link : ''}
                  />
                </div>
              </div>
              <div className="dropDownItem flex">
                <div className="flex flex-col w-1/2 mr-2">
                  <div className="mt-2 block uppercase tracking-wide text-gray-700 text-xs text-black font-bold">
                    Label:
                  </div>
                  <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    name="label-1"
                    onChange={handleDropdownItem}
                    type="text"
                    value={state?.dropDownItems ? state?.dropDownItems[1]?.label : ''}
                  />
                </div>
                <div className="flex flex-col w-1/2">
                  <div className="mt-2 block uppercase tracking-wide text-gray-700 text-xs text-black font-bold">
                    Link:
                  </div>
                  <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    name="link-1"
                    onChange={handleDropdownItem}
                    type="text"
                    value={state?.dropDownItems ? state?.dropDownItems[1]?.link : ''}
                  />
                </div>
              </div>
              <div className="dropDownItem flex">
                <div className="flex flex-col w-1/2 mr-2">
                  <div className="mt-2 block uppercase tracking-wide text-gray-700 text-xs text-black font-bold">
                    Label:
                  </div>
                  <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    name="label-2"
                    onChange={handleDropdownItem}
                    type="text"
                    value={state?.dropDownItems ? state?.dropDownItems[2]?.label : ''}
                  />
                </div>
                <div className="flex flex-col w-1/2">
                  <div className="mt-2 block uppercase tracking-wide text-gray-700 text-xs text-black font-bold">
                    Link:
                  </div>
                  <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    name="link-2"
                    onChange={handleDropdownItem}
                    type="text"
                    value={state?.dropDownItems ? state?.dropDownItems[2]?.link : ''}
                  />
                </div>
              </div>
              <div className="dropDownItem flex">
                <div className="flex flex-col w-1/2 mr-2">
                  <div className="mt-2 block uppercase tracking-wide text-gray-700 text-xs text-black font-bold">
                    Label:
                  </div>
                  <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    name="label-3"
                    onChange={handleDropdownItem}
                    type="text"
                    value={state?.dropDownItems ? state?.dropDownItems[3]?.label : ''}
                  />
                </div>
                <div className="flex flex-col w-1/2">
                  <div className="mt-2 block uppercase tracking-wide text-gray-700 text-xs text-black font-bold">
                    Link:
                  </div>
                  <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    name="link-3"
                    onChange={handleDropdownItem}
                    type="text"
                    value={state?.dropDownItems ? state?.dropDownItems[3]?.link : ''}
                  />
                </div>
              </div>
            </div>
          </div>
        )
      }
      {
        isDestinationLayout && (
          <div>
            <label htmlFor="url" className=" mb-2 block uppercase tracking-wide text-gray-700 text-xs text-black font-bold">
              Url
              <input
                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                name="url"
                onChange={handleUrl}
                type="text"
                value={state?.url}
              />
            </label>
          </div>
        )
      }
      <div className="flex bg-cover rounded-br-lg"
        style={{
          minHeight: 700,
          backgroundImage: `url(${currentBgImageIs})`
        }}
      >
        <div className="flex absolute right-0 bg-black h-80px w-48">
        <button
          className="font-americaMonoBold text-xs pl-6 pr-5 py-2 rounded-full uppercase bg-greyFilter absolute right-0 flex flex-row items-center mt-5 mr-4 h-10"
          key={uuid()}
          type="button"
          onClick={toggleModal}
        >
          {state
            && state.hasOwnProperty('image')
            && state.image[activeLanguage]
            ? 'Change image'
            : 'Select image'
          }
          {state
            && state.hasOwnProperty('image')
            && state.image[activeLanguage] ? (
              <span className="font-icon icon-loading-arrows text-sm pl-2 text-black" />
            ) : (
              <span className="font-icon icon-add-button text-base font-bold pl-2" />
            )}
        </button>
        </div>
        <div className="flex absolute right-0 mt-16 mr-0 h-10 pl-6 pr-5 py-2 bg-black h-70px w-48">
          <label htmlFor="toggleValue" className="block uppercase text-xs items-center font-americaMonoBold text-white mr-4 self-center">Filter Layer</label>
          <div className="self-center relative inline-block w-10 align-middle select-none transition duration-200 ease-in">
            <input
              type="checkbox"
              name="showOpacity"
              onChange={handleOpacityLayer}
              checked={state?.showOpacity}
              className="outline-none toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"
            />
            <label htmlFor="toggleValue" className="toggle-label block overflow-hidden h-6 rounded-full bg-grey cursor-pointer" />
          </div>
        </div>
        <DragDropContext onDragEnd={onDragEnd}>
          <div className="flex w-full h-screen">
            {state
              && state.hasOwnProperty('image')
              && state.image[activeLanguage] && (
              <div
                className="w-1/6 h-full p-4"
                style={{ backgroundColor: 'rgba(0, 0, 0, .9)' }}
              >
                  <Droppable droppableId="items" isDropDisabled>
                    {(provided, snapshot) => (
                      <div
                        id="menu"
                        ref={provided.innerRef}

                        //style={getListStyleContent(snapshot.isDraggingOver)}
                      >
                        {items.map((item, index) => (
                          <Draggable
                            key={item.id}
                            draggableId={item.id}
                            index={index}
                          >
                            {(provided, snapshot) => (
                              <div
                                id="module-button"
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                style={getItemStyleContent(
                                  snapshot.isDragging,
                                  provided.draggableProps.style,
                                )}
                              >
                                {item.readableName}
                              </div>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </div>
              )}
            {state
              && state.hasOwnProperty('image')
              && state.image[activeLanguage] && (
              <div
                className="w-5/6 h-full flex items-end justify-evenly p-4"
                style={{ backgroundColor: 'rgba(0, 0, 0, .7)' }}
              >
                  <Droppable droppableId="selectedLeft">
                    {(provided, snapshot) => (
                      <div
                        id="sssleft-slider-container"
                        ref={provided.innerRef}
                        className="w-1/2 h-1/2 mr-10"
                        style={getListStyleType(
                          snapshot.isDraggingOver,
                          selectedLeft,
                        )}
                      >
                        {selectedLeft.length > 0
                          && selectedLeft.map((item, index) => (
                            <Draggable
                              key={item.id}
                              draggableId={item.id}
                              index={index}
                              activeLanguage={activeLanguage}
                            >
                              {(provided, snapshot) => (
                                <div
                                  id={`left-content${index}`}
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  style={getItemStyleType(
                                    snapshot.isDragging,
                                    provided.draggableProps.style,
                                  )}
                                  className="relative"
                                >
                                  <div
                                    className="bg-greyFilterItems text-grey-avatar absolute h-full px-1 z-10 pin-l pin-t flex items-center justify-center "
                                    {...provided.dragHandleProps}
                                  >
                                    =
                                  </div>
                                  <button
                                    className="absolute pin-l pin-t"
                                    style={{
                                      marginTop: '-20px',
                                      marginLeft: '2px',
                                    }}
                                    type="button"
                                  >
                                    <span className="px-4 font-americaMonoBold text-xxs text-white bg-black rounded">
                                      {item.readableName}
                                    </span>
                                  </button>
                                  <button
                                    className="absolute pin-r pin-t h-4 w-4 flex items-center justify-center bg-black rounded-full"
                                    style={{
                                      marginTop: '-20px',
                                      marginRight: '2px',
                                    }}
                                    type="button"
                                    onClick={() => {
                                      handleBlockClose(item.id, 'left');
                                    }}
                                  >
                                    <span className="font-icon icon-close-btn1 text-base text-white" />
                                  </button>
                                  {item.content === 'TitleLineH1' && (
                                    <TitleLineH1
                                      id={item.id}
                                      languages={languages}
                                      components={selectedLeft}
                                      activeLanguage={activeLanguage}
                                      handlerSetComponents={
                                        handlerSetNestedComponentsLeft
                                      }
                                      slider
                                    />
                                  )}
                                  {item.content === 'SimpleTag' && (
                                    <SimpleTag
                                      id={item.id}
                                      languages={languages}
                                      components={selectedLeft}
                                      activeLanguage={activeLanguage}
                                      handlerSetComponents={
                                        handlerSetNestedComponentsLeft
                                      }
                                      slider
                                    />
                                  )}
                                  {item.content === 'LinkButtonRounded' && (
                                    <LinkButtonRounded
                                      id={item.id}
                                      languages={languages}
                                      components={selectedLeft}
                                      activeLanguage={activeLanguage}
                                      handlerSetComponents={
                                        handlerSetNestedComponentsLeft
                                      }
                                      slider
                                    />
                                  )}
                                  {item.content === 'SubtitleLineH2' && (
                                    <SubtitleLineH2
                                      id={item.id}
                                      languages={languages}
                                      components={selectedLeft}
                                      activeLanguage={activeLanguage}
                                      handlerSetComponents={
                                        handlerSetNestedComponentsLeft
                                      }
                                      slider
                                    />
                                  )}
                                  {item.content === 'PretitleLineH2' && (
                                    <PretitleLineH2
                                      id={item.id}
                                      languages={languages}
                                      components={selectedLeft}
                                      activeLanguage={activeLanguage}
                                      handlerSetComponents={
                                        handlerSetNestedComponentsLeft
                                      }
                                      slider
                                    />
                                  )}
                                </div>
                              )}
                            </Draggable>
                          ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                  <Droppable droppableId="selectedRight">
                    {(provided, snapshot) => (
                      <div
                        id="ssright-slider-container"
                        className="w-1/2 h-1/2"
                        ref={provided.innerRef}
                        style={getListStyleType(snapshot.isDraggingOver)}
                      >
                        {selectedRight.length > 0
                          && selectedRight.map((item, index) => (
                            <Draggable
                              key={item.id}
                              draggableId={item.id}
                              index={index}
                              activeLanguage={activeLanguage}
                            >
                              {(provided, snapshot) => (
                                <div
                                  id={`right-content${index}`}
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  style={getItemStyleType(
                                    snapshot.isDragging,
                                    provided.draggableProps.style,
                                  )}
                                  className="relative"
                                >
                                  <div
                                    className="bg-greyFilterItems text-grey-avatar absolute h-full px-1 z-10 pin-l pin-t flex items-center justify-center "
                                    {...provided.dragHandleProps}
                                  >
                                    =
                                  </div>
                                  <button
                                    className="absolute pin-l pin-t"
                                    style={{
                                      marginTop: '-20px',
                                      marginLeft: '2px',
                                    }}
                                    type="button"
                                  >
                                    <span className="px-4 font-americaMonoBold text-xxs text-white bg-black rounded">
                                      {item.readableName}
                                    </span>
                                  </button>
                                  <button
                                    className="absolute pin-r pin-t h-4 w-4 flex items-center justify-center bg-black rounded-full"
                                    style={{
                                      marginTop: '-20px',
                                      marginRight: '2px',
                                    }}
                                    type="button"
                                    onClick={() => {
                                      handleBlockClose(item.id, 'right');
                                    }}
                                  >
                                    <span className="font-icon icon-close-btn1 text-base text-white mt-1neg" />
                                  </button>

                                  {item.content === 'TitleLineH1' && (
                                    <TitleLineH1
                                      id={item.id}
                                      languages={languages}
                                      components={selectedRight}
                                      activeLanguage={activeLanguage}
                                      handlerSetComponents={
                                        handlerSetNestedComponentsRight
                                      }
                                      slider
                                    />
                                  )}
                                  {item.content === 'SimpleTag' && (
                                    <SimpleTag
                                      id={item.id}
                                      languages={languages}
                                      components={selectedRight}
                                      activeLanguage={activeLanguage}
                                      handlerSetComponents={
                                        handlerSetNestedComponentsRight
                                      }
                                      slider
                                    />
                                  )}
                                  {item.content === 'LinkButtonRounded' && (
                                    <LinkButtonRounded
                                      id={item.id}
                                      languages={languages}
                                      components={selectedRight}
                                      activeLanguage={activeLanguage}
                                      handlerSetComponents={
                                        handlerSetNestedComponentsRight
                                      }
                                      slider
                                    />
                                  )}
                                  {item.content === 'SubtitleLineH2' && (
                                    <SubtitleLineH2
                                      id={item.id}
                                      languages={languages}
                                      components={selectedRight}
                                      activeLanguage={activeLanguage}
                                      handlerSetComponents={
                                        handlerSetNestedComponentsRight
                                      }
                                      slider
                                    />
                                  )}
                                  {item.content === 'PretitleLineH2' && (
                                    <PretitleLineH2
                                      id={item.id}
                                      languages={languages}
                                      components={selectedRight}
                                      activeLanguage={activeLanguage}
                                      handlerSetComponents={
                                        handlerSetNestedComponentsRight
                                      }
                                      slider
                                    />
                                  )}
                                </div>
                              )}
                            </Draggable>
                          ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </div>
              )}
          </div>
        </DragDropContext>
      </div>
      {isModalOn && (
        <Modal handleClick={toggleModal} positionMiddle zIndex="10">
          <SingleObjUploaderWithSelector selectCallback={setImage} />
        </Modal>
      )}
    </>
  );
};

export default Slider;
